
$(document).ready(function () {
    $(".feeds-slick-slider").slick({
        dots: false,
        arrows: false,
        infinite: true,
        autoplay: true,
        autoplaySpeed: 0,
        pauseOnHover: true,
        cssEase: 'linear',	
        speed: 6000,
        slidesToShow: 6,
        slidesToScroll: 1,
        responsive: [
          {
          breakpoint: 1199,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 1,
          }
        },
        {
          breakpoint: 991,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
          }
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
          }
        }
      ]
    });
});